/**
 * VIDEO MODAL MODULE
 *
 * Dynamic Youtube video popup
 * Uses a single modal popup for all youtube video popup calls
 */

VP = window.VP || {};

(function( $ ) {
	/**
	 * PRIVATE VARIABLES
	 */
	var SELECTOR = {
		modal: '.js-video-modal',
		close: '.js-video-modal__close',
		iframe: '.js-video-modal__iframe',
		launcher: '.js-video-modal-launcher',
		dialog: '.js-video-modal__dialog',
	};
	var CLASSNAME = {
		ready: 'vp-video-modal--ready',
		opaque: 'vp-video-modal--opaque',
		body: 'vp-modal-opened',
		typeurl: 'vp-modal-type-url',
		typevideo:'vp-modal-type-video',
	};
	var PATTERNS = {
		validYoutubeURL: /^((?:https?:\/\/)?(?:www[.])?)?((?:youtube\.com)\/.*((?:v[/]|v[=])[^&]+)|(?:youtu\.be\/([^?])+))/i,
		youtubeIDMatcher: /(?:v=|v\/|\youtu.be\/)([^?&]+)/i,
		validFBURL: /(?:https?:\/\/)?(?:www\.)?facebook\.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[\w\-]*\/)*([\w\-\.]*)/i,
		fbIDMatcher: /^.*\/((.*)\=)?([0-9]*)$/i
	};
	var EMBED_URL_TEMPLATE = 'https://www.youtube.com/embed/{id}?autoplay=1&enablejsapi=1';
	var EMBED_URL_TEMPLATE_FB = 'https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fvisitphilly%2Fvideos%2F{id}%2F&show_text=0&width=560&autoplay=0';
	var $window = $(window);
	var $html = $('html');
	var $body = $('body');

	/**
	 * PRIVATE FUNCTIONS
	 */
	function parseYoutubeVideoID ( url ) {
		if ( !PATTERNS.validYoutubeURL.test(url) ) { return; }
		var match = url.match(PATTERNS.youtubeIDMatcher);
		return match ? match[1] : null;
	}

	function parseFBVideoID( url )  {
		if ( !PATTERNS.validFBURL.test(url) ) { return; }
		var match = url.match(PATTERNS.fbIDMatcher);
		return match ? match[match.length - 1] : null;
	}

	/**
	 * VIDEO MODAL CLASS
	 */
	var VideoModal = function ($element) {

		// Just ensure we have a jQuery object here
		this.$element = $($element);
		this.element = this.$element[0];

		this.$iframe = this.$element.find( SELECTOR.iframe );
		this.$close = this.$element.find( SELECTOR.close );
		this.$dialog = this.$element.find( SELECTOR.dialog );

		this.bindClose();
		this.bindEscClose();
		this.bindTransitionEnd();

		this.setReady();
	};

	VideoModal.prototype = $.extend({}, VideoModal.prototype, {
		bindClose: function () {
			var _this = this;
			this.$close.on('click', function () {
				_this.pauseVideo();
				_this.hideModal();
			});
		},

		bindEscClose: function () {
			var _this = this;

			$( document ).keyup( function( e ) {
				if ( e.which === 27 &&  $body.hasClass( CLASSNAME.body ) ) {
					_this.pauseVideo();
					_this.hideModal();
				}
			});
		},

		// Instead of timed class removal, Listen to transitionend for more accuracy
		// Just test whether opaque class has been removed to hide
		bindTransitionEnd: function () {
			var _this = this;
			this.$element.bind('transitionend', function (e) {
				if ( e.target !== _this.element ) { return; }

				if ( _this.$element.hasClass( CLASSNAME.opaque ) ) { return; }

				_this.allowBackgroundScroll();
				_this.detach();
			});
		},

		preventBackgroundScroll: function () {
			VP.bodyScroll.disable();
		},

		allowBackgroundScroll: function () {
			VP.bodyScroll.enable();
		},



		showIFrame: function (iframeURL ) {
			var _this = this;

			$body.addClass( CLASSNAME.body );

			this.$dialog.removeClass( CLASSNAME.typevideo );
			this.$dialog.addClass( CLASSNAME.typeurl );

			if (iframeURL.indexOf("opentable.com") > -1) {
				this.$dialog.attr("data-partner", "opentable");
			}


			// Attach to DOM
			this.attach();
			this.preventBackgroundScroll();

			// fade modal in
			setTimeout( this.fadeIn.bind( this ), 1 );


			this.$iframe[0].src = iframeURL;
			this.currentVideoID = iframeURL;

		},

		showVideo: function ( videoURL , $elem) {
			var _this = this;

			//tempcode for podbean, refactor to work better
			if ( videoURL.indexOf("podbean") > -1) {
				// console.log("locating and playing podbean");
				$img = $elem.parents("figure").first();
				// console.log($img);
				$player = $img.nextAll(".vp-frameholderalt,iframe").find("iframe");
				_top = $player.offset().top - $(".vp-header").height() - 10;
				$("html, body").animate({ scrollTop: _top + "px" }, 500);
				// console.log($player);

				podbeanwidget = new PB($player.get());
				// console.log(podbeanwidget);
				podbeanwidget.play();


				return;
			}

			var videourl = ""
			var videoID = parseYoutubeVideoID(videoURL);
			videourl =  EMBED_URL_TEMPLATE.replace( '{id}', videoID );
			if (!videoID) { // try facebook
				videoID = parseFBVideoID(videoURL);
				videourl = EMBED_URL_TEMPLATE_FB.replace( '{id}', videoID );
			}

			$body.addClass( CLASSNAME.body );

			this.$dialog.removeClass( CLASSNAME.typeurl );
			this.$dialog.addClass( CLASSNAME.typevideo );
			this.$dialog.attr("data-partner", "");

			if ( !videoID ) { return console.error('Please provide a valid YouTube video or Facebook video URL.'); }

			// Attach to DOM
			this.attach();
			this.preventBackgroundScroll();

			// fade modal in
			setTimeout( this.fadeIn.bind( this ), 1 );

			// If video is already loaded, just play it
			if ( this.currentVideoID === videoID ) {
				this.playVideo();
			// assign iframe src autoplay
			} else {
				this.$iframe[0].src = videourl;
				this.currentVideoID = videoID;
			}
		},

		setReady: function () {
			this.$element.addClass( CLASSNAME.ready );
			this.detach();
		},

		playVideo: function () {
			this.$iframe[0].contentWindow.postMessage( '{"event":"command","func":"playVideo","args":""}', '*' );
		},

		pauseVideo: function () {
			this.$iframe[0].contentWindow.postMessage( '{"event":"command","func":"pauseVideo","args":""}', '*' );
		},

		attach: function () {
			this.$element.appendTo( $body );
		},

		fadeIn: function () {
			this.$element.addClass( CLASSNAME.opaque );
		},

		hideModal: function () {
			this.$element.removeClass( CLASSNAME.opaque );
			$body.removeClass( CLASSNAME.body );
		},

		// Softly removes from DOM (event handlers are kept)
		detach: function () {
			this.$element = this.$element.detach();
		},

		// Binds a launcher button/CTA/element to this video modal
		bindLauncher: function ( $elements ) {
			var _this = this;

			$elements = $($elements);
			$elements.each(function ( index, element ) {
				var $element = $(element);
				var videoURL = $element.data('videoUrl');

				if ( !videoURL ) { return; }

				// Prevent duplicate binding
				if ( $element.data('videoModal') ) { return; }

				// Bind click
				$element
				.on( 'click', function (e) {
					e.stopPropagation();
					e.preventDefault();

					// manually fire event
					elabel = $(this).attr("data-video-url");
					eaction = $(this).attr("data-video-number"); // set with custom tag in GTM // GA Events - Video Click Tracking Init
					VP.helpers.firecustomGTMEvent("videoShow",elabel,eaction);

					_this.showVideo( videoURL , $( this ));
				})
				.data('videoModal', _this);
			});
		}
	});

	/**
	 * VIDEO MODAL MODULE ATTACHED TO APP
	 */
	var $element = $( SELECTOR.modal );
	var $launchers = $( SELECTOR.launcher );

	if ( $element.length ) {
		VP.videoModal = new VideoModal($element);
		VP.videoModal.bindLauncher( $launchers );
	}
})(jQuery);
